var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg055Minimize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 8H17C16.4477 8 16 7.55228 16 7V4C16 3.44772 15.5523 3 15 3C14.4477 3 14 3.44772 14 4V7C14 8.65685 15.3431 10 17 10H20C20.5523 10 21 9.55228 21 9C21 8.44772 20.5523 8 20 8ZM10 20C10 20.5523 9.55228 21 9 21C8.44772 21 8 20.5523 8 20V17C8 16.4477 7.55228 16 7 16H4C3.44772 16 3 15.5523 3 15C3 14.4477 3.44772 14 4 14H7C8.65685 14 10 15.3431 10 17V20ZM17 14H20C20.5523 14 21 14.4477 21 15C21 15.5523 20.5523 16 20 16H17C16.4477 16 16 16.4477 16 17V20C16 20.5523 15.5523 21 15 21C14.4477 21 14 20.5523 14 20V17C14 15.3431 15.3431 14 17 14ZM9 3C9.55228 3 10 3.44772 10 4V7C10 8.65685 8.65685 10 7 10H4C3.44772 10 3 9.55228 3 9C3 8.44772 3.44772 8 4 8H7C7.55228 8 8 7.55228 8 7V4C8 3.44772 8.44772 3 9 3Z",
    fill: "#8199A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg055Minimize);
export default __webpack_public_path__ + "static/media/055-minimize.4ec2217cadd4a431ab0761bab4a4e919.svg";
export { ForwardRef as ReactComponent };